import { types } from '../types';

export const downloadAddinsReducer = (
	state = {
		showDownloadButton: false,
	},
	action: any,
) => {
	switch (action.type) {
		case types.DOWNLOAD_ADDINS_SHOW:
			return {
				...state,
				showDownloadButton: action.show,
			};
		default:
			return state;
	}
};
